(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

		const lightboxBlocksArr = document.querySelectorAll('.trusler-block--video-lightbox');

		lightboxBlocksArr.forEach(block => {

			const card = block.querySelector('.wrap--parcel-video-lightbox');
		  
			ParcelFunctions.inViewport(card, 0.3, 0.15, 'card-in-viewport');

		});		

	});

})(jQuery);